import { handleRequestPost, handleRequestGet } from '../axios';
import { parseResult, queryParamStr, queryParamStrArr } from './GeneralFunc';

export const getTrustDetail = async (a_id = null, currency = 1) => {
    let url = '/client/account/' + a_id + '/trust/currency/' + currency;
    let result = await handleRequestGet(url, {});
    return parseResult(result).account || null;
};

export const getTrustDetailOption = async (a_id = null, currency = 1) => {
    let url = '/client/account/' + a_id + '/trust/options';
    let result = await handleRequestGet(url, {});
    return parseResult(result)
     || null;
};
